import { isEmpty } from "lodash";
import { LoadingDots } from "PFComponents/loading_dots";
import { useExportFields } from "PFCore/hooks/queries/analytics/booking_export/use_export_fields";
import React, { JSX, useMemo, useState } from "react";

import { findMatchingFields } from "../../../export_fields_utils";
import css from "./fields_management.module.scss";
import { FieldsSelector } from "./fields_selector";
import { FieldsViewer } from "./fields_viewer";
import { SearchBox } from "./search_box";

export const FieldsManagement = (): JSX.Element => {
  const { data, isLoading } = useExportFields();
  const [searchKeyword, setSearchKeyword] = useState<string | null>(null);

  const items = useMemo(() => {
    if (isEmpty(searchKeyword)) {
      return data?.entries || {};
    }

    return findMatchingFields(data?.entries || {}, searchKeyword?.toLowerCase());
  }, [data, searchKeyword]);

  return (
    <div>
      <SearchBox value={searchKeyword} onChange={(value) => setSearchKeyword(value)} />
      {isLoading && <LoadingDots circlesEnabled className={css.loading} />}
      {items && (
        <>
          <FieldsViewer items={items} />
          <FieldsSelector items={items} allExpanded={!!searchKeyword} />
        </>
      )}
    </div>
  );
};
